export default __webpack_public_path__ + "static/media/3_RIVER_GREY_120X278_265.ad644545.jpg";